(function (angular) {

  angular.module("alk.geocode", []);

})(window.angular);

require("./geocode.service");



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-geocode/module.js